import { Component, OnInit, ViewChild, ElementRef, OnDestroy, AfterViewInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { NavParams, LoadingController, ModalController } from '@ionic/angular';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { GUIService } from '../../gui.service';
import { SAMService } from 'src/app/sam/sam.service';
import { ConfigService } from 'src/app/config.service';
import { ThemeService } from 'ngx-elvis-ds';
import { BasePage } from 'ngx-elvis-ds';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export class PDFViewerDialogCommands {
  public static OPEN = ['PDF_VIEWER_OPEN'];
  public static UPDATE = [];
  public static CLOSE = ['PDF_VIEWER_CLOSE'];
}

@Component({
  selector: 'app-pdf-viewer-dialog',
  templateUrl: './pdf-viewer-dialog.page.html',
  styleUrls: ['./pdf-viewer-dialog.page.scss'],
})
export class PDFViewerDialogPage extends BasePage implements OnInit {

  @ViewChild('pdfViewerDialog', { static: true }) pdfViewerDialog: ElementRef;
  @Input() data: any;

  filename: string;
  fileURL: SafeResourceUrl;
  
  constructor(
    public config: ConfigService,
    public themeSvc: ThemeService,
    public guiSvc: GUIService,
    private sanitizer: DomSanitizer,
    private modalCtrl: ModalController
  ) {
    super();
  }

  ngOnInit() {
    let assetBase = 'http://xcloud.xpos.host:8080';

    if (this.config.assetsSettings) {
      assetBase = this.config.assetsSettings.address;
    }

    this.filename = this.data.Filename;
    this.fileURL = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${assetBase}/assets/lib/pdf-viewer/web/viewer.html?file=${assetBase}/${this.filename}`
    );
  }

  onDismiss() {
    this.modalCtrl.dismiss();
  }
}
